import {
    AppRouterInstance,
    NavigateOptions,
} from 'next/dist/shared/lib/app-router-context.shared-runtime';

export interface IMockCustomAppRouter extends Omit<AppRouterInstance, 'push'> {
    push: (href: string, options?: NavigateOptions) => void;
    redirect: (href: string) => void;
}

export function createMockRouter(router?: Partial<IMockCustomAppRouter>): IMockCustomAppRouter {
    const mockRouter: IMockCustomAppRouter = {
        back: jest.fn(),
        forward: jest.fn(),
        prefetch: jest.fn(),
        push: jest.fn(),
        redirect: jest.fn(),
        replace: jest.fn(),
        refresh: jest.fn(),
        ...router,
    };

    return mockRouter;
}
